//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.NullableAnyAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.UpsertInspectionMutation
import kotlin.Any
import kotlin.String
import kotlin.collections.List

public object UpsertInspectionMutation_ResponseAdapter {
  public object Data : Adapter<UpsertInspectionMutation.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("upsertInspection")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): UpsertInspectionMutation.Data {
      var _upsertInspection: UpsertInspectionMutation.UpsertInspection? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _upsertInspection = UpsertInspection.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return UpsertInspectionMutation.Data(
        upsertInspection = _upsertInspection ?: missingField(reader, "upsertInspection")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: UpsertInspectionMutation.Data,
    ) {
      writer.name("upsertInspection")
      UpsertInspection.obj().toJson(writer, customScalarAdapters, value.upsertInspection)
    }
  }

  public object UpsertInspection : Adapter<UpsertInspectionMutation.UpsertInspection> {
    public val RESPONSE_NAMES: List<String> = listOf("lastUpdatedAt")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): UpsertInspectionMutation.UpsertInspection {
      var _lastUpdatedAt: Any? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _lastUpdatedAt = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return UpsertInspectionMutation.UpsertInspection(
        lastUpdatedAt = _lastUpdatedAt
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: UpsertInspectionMutation.UpsertInspection,
    ) {
      writer.name("lastUpdatedAt")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.lastUpdatedAt)
    }
  }
}
